import { render } from "./ClaimDataAnalyse.vue?vue&type=template&id=0d3fcaf2"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__